export default "__VITE_ASSET__BkPnlvFP__"